import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3 w-full" }
const _hoisted_2 = { class: "text-xl font-bold text-gray-900 px-1" }
const _hoisted_3 = { class: "bg-white border border-gray-200 md:shadow sm:rounded-lg w-full" }
const _hoisted_4 = {
  key: 0,
  class: "text-center text-gray-600 m-8"
}
const _hoisted_5 = {
  key: 1,
  class: "overflow-y-auto",
  style: {"height":"600px"}
}
const _hoisted_6 = { class: "w-full divide-y divide-gray-200 text-left hidden md:table" }
const _hoisted_7 = { class: "bg-gray-50 w-full" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { class: "w-1/12 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }, " # ", -1)
const _hoisted_10 = { class: "w-3/13 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_11 = { class: "w-3/12 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_12 = { class: "w-3/12 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_13 = { class: "w-3/12 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "w-2/12 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }, null, -1)
const _hoisted_15 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_16 = { class: "px-6 py-3 text-sm text-gray-500 w-1/12 relative" }
const _hoisted_17 = {
  key: 0,
  class: "absolute bg-gray-50 p-0.5 text-xs",
  style: {"top":"-11px","left":"45px"}
}
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "px-6 py-3 text-sm text-gray-500 w-3/12" }
const _hoisted_20 = { class: "px-6 py-3 text-sm text-gray-500 w-3/12" }
const _hoisted_21 = { class: "px-6 py-3 text-sm text-gray-500 w-3/12" }
const _hoisted_22 = { class: "px-6 py-3 text-sm text-gray-500 w-2/12" }
const _hoisted_23 = { class: "flex justify-end gap-3" }
const _hoisted_24 = { class: "flex flex-col md:hidden" }
const _hoisted_25 = { class: "flex justify-between p-3" }
const _hoisted_26 = { class: "text-gray-500 font-medium" }
const _hoisted_27 = { class: "flex gap-2" }
const _hoisted_28 = { class: "grid grid-cols-2 items-center border-b" }
const _hoisted_29 = { class: "px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_30 = { class: "py-2 text-sm text-gray-500" }
const _hoisted_31 = { class: "grid grid-cols-2 items-center border-b" }
const _hoisted_32 = { class: "px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_33 = { class: "py-2 text-sm text-gray-500" }
const _hoisted_34 = { class: "grid grid-cols-2 items-center border-b" }
const _hoisted_35 = { class: "px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_36 = { class: "py-2 text-sm text-gray-500" }
const _hoisted_37 = { class: "flex flex-col md:flex-row w-full" }
const _hoisted_38 = { class: "flex items-center flex-wrap w-full mb-2 md:mb-0" }
const _hoisted_39 = {
  key: 0,
  class: "text-red-900 text-center md:text-right text-sm"
}

import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/vue/24/solid";
import { useUpdateProjectDurationSettings } from "@oculai/planner";
import { format, getYear, intervalToDuration, parse } from "date-fns";
import { Form, GenericObject, SubmissionHandler } from "vee-validate";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { onBeforeRouteUpdate } from "vue-router";
import { PropType } from "vue/dist/vue";
import * as yup from "yup";
import LoadingSpinner from "@/components/UI/LoadingSpinner.vue";
import MainButton from "@/components/UI/MainButton.vue";
import { useSaveBeforeLeaveConfirmationModal } from "@/composables/toast";
import { apiClient } from "@/repositories/clients";
import { Project } from "@/types/Project";
import { NonWorkingDay, ProjectDurationSettings } from "@/types/ProjectDurationSettings";
import NonWorkingDayModal from "@/views/settings/project/NonWorkingDayModal.vue";
import PublicHolidaysModal from "@/views/settings/project/PublicHolidaysModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NonWorkingDays',
  props: {
  projectDurationSettings: {
    type: Object as PropType<ProjectDurationSettings>,
    required: true,
  },
  project: {
    type: Object as PropType<Project>,
    required: true,
  },
},
  setup(__props) {

const { t } = useI18n();

const { updateProjectDurationSettings, isUpdateError } =
  useUpdateProjectDurationSettings(apiClient);
const showSaveBeforeLeaveConfirmationModal = useSaveBeforeLeaveConfirmationModal();

const formRef = ref<typeof Form | null>(null);

onBeforeRouteUpdate((to, from, next) => {
  const meta = formRef.value?.meta;

  if (!meta?.dirty) {
    return next();
  }
  showSaveBeforeLeaveConfirmationModal().then((confirmed) => {
    if (confirmed) {
      next();
    }
  });
});

const props = __props;

const editedNonWorkingDay = ref<NonWorkingDay | null>(null);
const isAddModalVisible = ref(false);
const isPublicHolidaysModalVisible = ref(false);

const schema = computed(() =>
  yup.object({
    non_working_days: yup.array().of(
      yup.object({
        name: yup.string().required(),
        start_date: yup.date().required(),
        end_date: yup.date().required(),
      }),
    ),
  }),
);

const minDate = computed(() =>
  parse(`${getYear(props.project.planned_start) - 1}-01-01`, "yyyy-MM-dd", new Date()),
);

const maxDate = computed(() =>
  parse(`${getYear(props.project.planned_end) + 1}-12-31`, "yyyy-MM-dd", new Date()),
);

const initialValues = computed(() => ({
  non_working_days: props.projectDurationSettings.non_working_days,
}));

const handleSubmit: SubmissionHandler = async (genericObject, { resetForm }) => {
  try {
    await updateProjectDurationSettings({ non_working_days: genericObject.non_working_days });
    resetForm({ values: initialValues.value });
  } catch {
    // have to catch the error here, otherwise it's propagated as an unhandled error
    // it's already logged by vue-query
    return undefined;
  }
};

const getMergedHolidays = (non_working_days: NonWorkingDay[], publicHolidays: NonWorkingDay[]) => {
  return [
    ...non_working_days.filter(
      (nwd) =>
        nwd.type !== "public_holiday" ||
        (nwd.type === "public_holiday" &&
          !publicHolidays.some(
            (publicHoliday) =>
              publicHoliday.start_date.getTime() === nwd.start_date.getTime() &&
              publicHoliday.end_date.getTime() === nwd.end_date.getTime(),
          )),
    ),
    ...publicHolidays,
  ];
};

const formatDate = (holiday: NonWorkingDay) => {
  if (!holiday.start_date || !holiday.end_date) {
    return "";
  }
  if (holiday.start_date.getTime() === holiday.end_date.getTime()) {
    return format(holiday.start_date, "dd.MM.yyyy");
  }
  return `${format(holiday.start_date, "dd.MM.yyyy")} - ${format(holiday.end_date, "dd.MM.yyyy")}`;
};

const hasChangeInYear = (values: GenericObject, index: number, non_working_day: NonWorkingDay) =>
  non_working_day &&
  values.non_working_days[index - 1] &&
  getYear(non_working_day.start_date) !== getYear(values.non_working_days[index - 1].start_date);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_header")), 1),
    _createVNode(_unref(Form), {
      onSubmit: handleSubmit,
      initialValues: initialValues.value,
      validationSchema: schema.value,
      class: "flex flex-col gap-3",
      ref_key: "formRef",
      ref: formRef
    }, {
      default: _withCtx(({ isSubmitting, values, meta, setFieldValue }) => [
        _createElementVNode("div", _hoisted_3, [
          (values.non_working_days.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)("admin.durations_project_settings.no_holidays_message")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("thead", _hoisted_7, [
                    _createElementVNode("tr", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_name")), 1),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_date")), 1),
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_type")), 1),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_duration")), 1),
                      _hoisted_14
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.non_working_days, (nonWorkingDay, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: _normalizeClass(["text-gray-700", hasChangeInYear(values, index, nonWorkingDay) ? '!border-gray-400' : ''])
                      }, [
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("div", null, _toDisplayString(index + 1), 1),
                          (hasChangeInYear(values, index, nonWorkingDay))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(getYear)(nonWorkingDay.start_date)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", {
                          class: "px-6 py-3 text-sm text-gray-500 truncate w-3/12",
                          title: nonWorkingDay.name
                        }, _toDisplayString(nonWorkingDay.name), 9, _hoisted_18),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(formatDate(nonWorkingDay)), 1),
                        _createElementVNode("td", _hoisted_20, [
                          _createElementVNode("span", {
                            class: "text-white px-1.5 py-1 rounded text-xs",
                            style: _normalizeStyle(
                      nonWorkingDay.type === 'disturbance'
                        ? 'background-color: #f5e3be; color: #9c7018'
                        : 'background-color: #bfdbfe4c; color: #1d4ed8'
                    )
                          }, _toDisplayString(_ctx.$t(
                        `admin.durations_project_settings.non_working_day_type_labels.${nonWorkingDay.type}`,
                      )), 5)
                        ]),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(nonWorkingDay.start_date &&
                    nonWorkingDay.end_date &&
                    (_unref(intervalToDuration)({
                      start: nonWorkingDay.start_date,
                      end: nonWorkingDay.end_date,
                    }).days || 0) + 1), 1),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_unref(PencilIcon), {
                              class: "w-5 h-5 text-gray-600 cursor-pointer",
                              onClick: ($event: any) => (editedNonWorkingDay.value = nonWorkingDay)
                            }, null, 8, ["onClick"]),
                            _createVNode(_unref(TrashIcon), {
                              class: "lg:h-5 h-4 text-gray-600 cursor-pointer",
                              onClick: ($event: any) => (
                        setFieldValue(
                          'non_working_days',
                          values.non_working_days.filter(
                            (nwd) => nwd !== nonWorkingDay,
                          ),
                        )
                      )
                            }, null, 8, ["onClick"]),
                            (editedNonWorkingDay.value === nonWorkingDay)
                              ? (_openBlock(), _createBlock(NonWorkingDayModal, {
                                  key: 0,
                                  nonWorkingDay: nonWorkingDay,
                                  onClose: _cache[0] || (_cache[0] = ($event: any) => (editedNonWorkingDay.value = null)),
                                  onCommit: ($event: any) => {
                        editedNonWorkingDay.value = null;
                        setFieldValue(`non_working_days.${index}`, $event);
                      },
                                  minDate: minDate.value,
                                  maxDate: maxDate.value
                                }, null, 8, ["nonWorkingDay", "onCommit", "minDate", "maxDate"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.non_working_days, (nonWorkingDay, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "shadow mb-2"
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("h3", _hoisted_26, "#" + _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_unref(PencilIcon), {
                            class: "w-5 h-4 text-gray-600 cursor-pointer",
                            onClick: ($event: any) => (editedNonWorkingDay.value = nonWorkingDay)
                          }, null, 8, ["onClick"]),
                          _createVNode(_unref(TrashIcon), {
                            class: "lg:h-5 h-4 text-gray-600 cursor-pointer",
                            onClick: ($event: any) => (
                      setFieldValue(
                        'non_working_days',
                        values.non_working_days.filter(
                          (nwd) => nwd !== nonWorkingDay,
                        ),
                      )
                    )
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_name")), 1),
                        _createElementVNode("div", _hoisted_30, _toDisplayString(nonWorkingDay.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_date")), 1),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(formatDate(nonWorkingDay)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_duration")), 1),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(nonWorkingDay?.start_date &&
                    nonWorkingDay?.end_date &&
                    (_unref(intervalToDuration)({
                      start: nonWorkingDay?.start_date,
                      end: nonWorkingDay?.end_date,
                    }).days || 0) + 1), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(MainButton, {
              onClicked: _cache[1] || (_cache[1] = ($event: any) => (isPublicHolidaysModalVisible.value = true)),
              class: "w-full md:w-auto text-white bg-green-500 hover:bg-green-700",
              label: _unref(t)('admin.durations_project_settings.add_public_holidays_button'),
              type: "button"
            }, null, 8, ["label"]),
            _createVNode(MainButton, {
              onClicked: _cache[2] || (_cache[2] = ($event: any) => (isAddModalVisible.value = true)),
              label: _unref(t)('buttons.add'),
              type: "button",
              color: "yellow",
              class: "w-full md:w-auto md:ml-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PlusIcon), { class: "h-5 w-5 cursor-pointer" })
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode(MainButton, {
            label: _ctx.$t('buttons.save'),
            type: "submit",
            color: "yellow",
            class: "sm:mr-0",
            isDisabled: isSubmitting || !meta.dirty
          }, {
            default: _withCtx(() => [
              (isSubmitting && meta.valid)
                ? (_openBlock(), _createBlock(LoadingSpinner, {
                    key: 0,
                    size: "w-5 h-5",
                    color: "white",
                    class: "mr-2"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["label", "isDisabled"])
        ]),
        (_unref(isUpdateError))
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(t)("admin.durations_project_settings.save_error_message")), 1))
          : _createCommentVNode("", true),
        (isAddModalVisible.value)
          ? (_openBlock(), _createBlock(NonWorkingDayModal, {
              key: 1,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (isAddModalVisible.value = false)),
              onCommit: ($event: any) => {
          isAddModalVisible.value = false;
          setFieldValue('non_working_days', [...values.non_working_days, $event]);
        },
              minDate: minDate.value,
              maxDate: maxDate.value
            }, null, 8, ["onCommit", "minDate", "maxDate"]))
          : _createCommentVNode("", true),
        (isPublicHolidaysModalVisible.value)
          ? (_openBlock(), _createBlock(PublicHolidaysModal, {
              key: 2,
              project: __props.project,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (isPublicHolidaysModalVisible.value = false)),
              onCommit: ($event: any) => {
          isPublicHolidaysModalVisible.value = false;
          setFieldValue('non_working_days', getMergedHolidays(values.non_working_days, $event));
        }
            }, null, 8, ["project", "onCommit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["initialValues", "validationSchema"])
  ]))
}
}

})